<app-main-navbar></app-main-navbar>

<!-- Page Title -->
<div class="page-title-area" [ngStyle]="{ 'background-image': 'url(' + pressRoomImage + ')' }">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <h1 class="text-start">{{ pressRoomTitle }}</h1>
        <h2 class="text-start">{{ pressRoomSubtitle }}</h2>
      </div>
    </div>
  </div>
  <div class="shape2 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
  <div class="shape3"><img src="assets/img/shapes/shape3.svg" alt="shape" /></div>
  <div class="shape4"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape5"><img src="assets/img/shapes/shape5.png" alt="shape" /></div>
  <div class="shape6 rotateme"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape7"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape8 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
</div>

<!-- Press -->
<div class="blog-area ptb-80">
  <div class="container">
    <div class="row">
      <app-news></app-news>
      <app-announcements></app-announcements>
      <app-press-inquiries></app-press-inquiries>
      <app-visit-blog></app-visit-blog>
      <app-media-kit></app-media-kit>
    </div>
  </div>
</div>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
